import TopUtilityBar from "../sections/TopUtilityBar";
import MainHeader from "../sections/MainHeader";
import Footer from "../sections/Footer";
import { useSeoMeta } from "../lib/seo";
import Button from "../components/loadout/Button";

export default function NotFound() {
  useSeoMeta({ title: "Page not found — Loadout", noindex: true });
  return (
    <div className="min-h-screen bg-white text-[#0A0A0A] flex flex-col">
      <TopUtilityBar />
      <MainHeader />
      <main className="flex-1 mx-auto max-w-[1440px] w-full px-6 py-24 flex flex-col items-start">
        <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">
          404 · OFF THE MAP
        </div>
        <h1 className="mt-4 font-display text-[#0A0A0A] text-[48px] md:text-[80px] leading-[0.95]">
          NO CONTACT.
        </h1>
        <p className="mt-4 font-sans text-[16px] text-[#8A8A8A] max-w-[520px]">
          The route you requested is not on our grid. Head back to base and pick
          another engagement.
        </p>
        <Button as="a" href="/" variant="primary" className="mt-8">
          Return to Base →
        </Button>
      </main>
      <Footer />
    </div>
  );
}
